export type colorPaletteTypes = {
  beigeDark: string;
  beigeLight: string;
  blueBase: string;
  blueGray: string;
  blueLight: string;
  brownDark: string;
  darkBase: string;
  gray10: string;
  gray20: string;
  gray30: string;
  gray40: string;
  gray50: string;
  gray60: string;
  gray80: string;
  gray90: string;
  greenBase: string;
  greenLight: string;
  pinkLight: string;
  primary: string;
  purpleDark: string;
  purpleLight: string;
  redLight: string;
  redMid: string;
  redSmooth: string;
  tealBase: string;
  turkizLight: string;
  white: string;
  yellowBase: string;
  yellowDark: string;
  owGray: string;
  fuguOrange: string;
};

export const colorPalette = {
  beigeDark: "#79796E",
  beigeLight: "#BAB0AC",
  blueBase: "#367FA9",
  blueGray: "#78909C",
  blueLight: "#A0CBE8",
  brownDark: "#9D7660",
  darkBase: "#212121",
  gray10: "#F7F9FA",
  gray20: "#F1F3F4",
  gray30: "#E3E5E6",
  gray40: "#C6CACC",
  gray50: "#A6ADAF",
  gray60: "#919699",
  gray80: "#5E6366",
  gray90: "#3E4345",
  greenBase: "#2FA84F",
  greenLight: "#8CD17D",
  pinkLight: "#FABFD2",
  primary: "#CC0033",
  purpleDark: "#B07AA1",
  purpleLight: "#D4A6C8",
  redLight: "#FF9D9A",
  redMid: "#E15759",
  redSmooth: "#FEE4E2",
  tealBase: "#069697",
  turkizLight: "#86BCB6",
  white: "#ffffff",
  yellowBase: "#F3AA18",
  yellowDark: "#B6992D",
  owGray: "#4D4D4D",
  fuguOrange: "#FEAA0A",
};

export type chartColorPaletteTypes = {
  beryl: string;
  blue: string;
  camel: string;
  camellia: string;
  canaryYellow: string;
  cerulian: string;
  coastalGray: string;
  cocoa: string;
  cream: string;
  darkOlive: string;
  denimBlue: string;
  dragonFruit: string;
  flamingo: string;
  flash: string;
  fuguOrange: string;
  grapefruit: string;
  green: string;
  lavender: string;
  lavenderGray: string;
  lemonCream: string;
  lightBlue: string;
  lightOrange: string;
  lightPink: string;
  lilac: string;
  mellowYellow: string;
  mint: string;
  mistBlue: string;
  orange: string;
  papaya: string;
  peach: string;
  pebble: string;
  pink: string;
  pinkSand: string;
  pollen: string;
  purple: string;
  red: string;
  redRose: string;
  roseGold: string;
  seaFoam: string;
  softWhite: string;
  stormGray: string;
  surfBlue: string;
  turquoise: string;
  ultraViolet: string;
  yellow: string;
};

export const chartColorPalette = {
  beryl: "#D0F2B1",
  blue: "#1EA5FC",
  camel: "#A97D4F",
  camellia: "#BF3138",
  canaryYellow: "#FFDA3A",
  cerulian: "#87B9E7",
  coastalGray: "#715D50",
  cocoa: "#8B7D7D",
  cream: "#FFE0AB",
  darkOlive: "#7C7A66",
  denimBlue: "#4B709A",
  dragonFruit: "#F12E6D",
  flamingo: "#CA6F59",
  flash: "#DFF81E",
  fuguOrange: "#FEAA0A",
  grapefruit: "#FDA27E",
  green: "#80E220",
  lavender: "#A58998",
  lavenderGray: "#757397",
  lemonCream: "#FFEB6D",
  lightBlue: "#5EBAD9",
  lightOrange: "#FD820B",
  lightPink: "#F19F9D",
  lilac: "#A990DD",
  mellowYellow: "#F7F6AF",
  mint: "#A2EC8E",
  mistBlue: "#A7AB99",
  orange: "#FC4E12",
  papaya: "#FD7036",
  peach: "#E0694E",
  pebble: "#9F8D7E",
  pink: "#FD4154",
  pinkSand: "#FEB69C",
  pollen: "#FECB4D",
  purple: "#8962F8",
  red: "#DF1125",
  redRose: "#AB1438",
  roseGold: "#E99475",
  seaFoam: "CFF1D6",
  softWhite: "#D8C9AF",
  stormGray: "#578887",
  surfBlue: "#1871AC",
  turquoise: "#91CEC2",
  ultraViolet: "#5F41B2",
  yellow: "#E8C511",
};
